// src/components/user/express/ExpressStepIndicator.jsx
import React from 'react';
import { MapPin, Navigation, Bike, Package } from 'lucide-react';

const STEPS = [
  { label: 'Recojo',    icon: MapPin      },
  { label: 'Destino',   icon: Navigation  },
  { label: 'Vehículo',  icon: Bike        },
  { label: 'Productos', icon: Package     },
];

export function ExpressStepIndicator({ currentStep }) {
  return (
    <div className="w-full px-4 py-3">
      {/* Progress bar */}
      <div className="relative flex items-center justify-between mb-2">
        {/* Background line */}
        <div className="absolute left-0 right-0 top-1/2 -translate-y-1/2 h-1 bg-slate-200 rounded-full" />
        {/* Active line */}
        <div
          className="absolute left-0 top-1/2 -translate-y-1/2 h-1 bg-brand-green rounded-full transition-all duration-500"
          style={{ width: `${((currentStep - 1) / (STEPS.length - 1)) * 100}%` }}
        />
        {STEPS.map((step, idx) => {
          const stepNum   = idx + 1;
          const isDone    = stepNum < currentStep;
          const isActive  = stepNum === currentStep;
          const Icon      = step.icon;
          return (
            <div
              key={stepNum}
              className="relative z-10 flex flex-col items-center gap-1"
            >
              <div className={`
                w-9 h-9 rounded-full flex items-center justify-center transition-all duration-300 border-2
                ${isDone   ? 'bg-brand-green border-brand-green text-white'   : ''}
                ${isActive ? 'bg-white border-brand-green text-brand-green shadow-md scale-110' : ''}
                ${!isDone && !isActive ? 'bg-white border-slate-200 text-slate-400' : ''}
              `}>
                <Icon className="w-4 h-4" />
              </div>
            </div>
          );
        })}
      </div>
      {/* Labels */}
      <div className="flex justify-between">
        {STEPS.map((step, idx) => {
          const stepNum  = idx + 1;
          const isActive = stepNum === currentStep;
          const isDone   = stepNum < currentStep;
          return (
            <span
              key={stepNum}
              className={`text-xs font-montserrat font-semibold transition-colors duration-300 w-16 text-center
                ${isActive ? 'text-brand-green'  : ''}
                ${isDone   ? 'text-slate-400'    : ''}
                ${!isActive && !isDone ? 'text-slate-300' : ''}
              `}
            >
              {step.label}
            </span>
          );
        })}
      </div>
    </div>
  );
}